











import {
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  useContext,
} from '@nuxtjs/composition-api'
import loadScriptAsync from '@/helpers/loadScriptAsync'

export default defineComponent({
  name: 'SmartCaptcha',
  props: {
    id: {
      type: String,
      default: 'captcha-container',
    },
    invisible: {
      type: Boolean,
      default: false,
    },
    infinity: {
      type: Boolean,
      default: false,
    },
    test: {
      type: Boolean,
      default: false,
    },
    hideShield: {
      type: Boolean,
      default: false,
    },
    typeCaptcha: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const context = useContext()
    const widgetId = ref<number | null>(null)
    const container = ref<HTMLDivElement | null>()
    const unsubscribeFunction = ref<() => void | null>(null)
    const execute = () => {
      if (process.browser && widgetId.value != null) {
        window.smartCaptcha.execute(widgetId.value)
      }
    }

    const reset = () => {
      window.smartCaptcha.reset(widgetId.value)
    }

    onMounted(async () => {
      if (!process.browser || props.typeCaptcha !== 'yandex') return
      const { success } = await loadScriptAsync(
        'https://smartcaptcha.yandexcloud.net/captcha.js'
      )
      if (!success) return
      widgetId.value = window?.smartCaptcha.render(container.value, {
        sitekey: context.$config.SMART_CAPTCHA_SITEKEY,
        hl: 'ru',
        invisible: props.invisible,
        hideShield: props.hideShield,
        test: props.test,
      })

      unsubscribeFunction.value = window?.smartCaptcha.subscribe(
        widgetId.value,
        'success',
        (token: string) => {
          if (props.infinity) {
            window.smartCaptcha.reset(widgetId.value)
            window.smartCaptcha.execute(widgetId.value)
          }
          emit('input', !!token)
        }
      )
    })

    onUnmounted(() => {
      unsubscribeFunction.value?.()
    })

    return {
      container,
      execute,
      reset,
    }
  },
})
